<template>
  <v-card class="elevation-5">
    <Notification />
    <DataTable :operators="registrars" @open-block-modal="openModalHandler" />
    <BlockModal :item="modalItem" :show="isModalShow" @close-block-modal="closeModalHandler" />
  </v-card>
</template>

<script>
import BlockModal from '../components/operators/BlockModal'
export default {
  name: 'Registrars',
  components: {
    BlockModal,
    Notification: () => import('@/components/ui/Notification'),
    DataTable: () => import('@/components/operators/DataTable')
  },
  created() {
    this.$store.commit('SAVE_NAV_TITLE', 'Сотрудники')
  },
  async mounted() {
    try {
      await this.$store.dispatch('GET_USER_INFO')
      if (this.userRole && this.userRole !== 'registrar') {
        await this.$store.dispatch('GET_OPERATORS_LIST', {
          amount: this.itemsPerPage || 10,
          page: this.page || 1
        })
      }
    } catch (e) {}
  },
  destroyed() {
    this.$store.commit('CLEAR_OPERATORS')
  },
  data: () => ({
    modalItem: {},
    isModalShow: false
  }),
  computed: {
    registrars() {
      return this.$store.state.registrars.response.registrars
    },
    userRole() {
      return this.$store.state.user.role
    }
  },
  methods: {
    openModalHandler(item) {
      this.modalItem = item
      this.isModalShow = true
    },
    closeModalHandler() {
      this.isModalShow = false
    }
  }
}
</script>
